<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false"  />
        <div class="content-wrapper" v-loading="loading">
            <el-row>
                <el-col :span="24" class="content-right" >
                    <div class="search">
                        <el-form :inline="true" :model="searchForm" ref="searchForm" class="searchForm" >
                        <!-- <el-form-item class="item" prop="activityName">
                            <el-input v-model="searchForm.activityName" placeholder="活动主题" size="small" clearable></el-input>
                        </el-form-item> -->
                        <el-form-item class="item selcetItem" prop="themeId">
                            <el-select v-model="searchForm.themeId" :popper-append-to-body="false" placeholder="选择活动主题" filterable clearable size="small">
                                <el-option
                                v-for="item in themeList"
                                :key="item.themeId"
                                :label="item.themeName"
                                :value="item.themeId">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="blockName">
                            <el-input v-model="searchForm.blockName" placeholder="街区名称" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="pocName">
                            <el-input v-model="searchForm.pocName" placeholder="门店名称" size="small" clearable></el-input>
                        </el-form-item>
                        <el-form-item class="item" prop="buCode" v-if="isHq" >
                            <el-select v-model="searchForm.buCode" placeholder="选择BU" filterable  size="small" clearable @change="cahngeBu()">
                                <el-option
                                v-for="item in buArr"
                                :key="item.orgCode"
                                :label="item.orgName"
                                :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" style="width:170px" prop="regionCode" >
                            <el-select v-model="searchForm.regionCode" placeholder="选择销售大区" filterable  size="small" clearable>
                                <el-option
                                v-for="item in regionArr"
                                :key="item.orgCode"
                                :label="item.orgName"
                                :value="item.orgCode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" style="overflow: hidden;" prop="menuCode">
                            <el-select v-model="searchForm.menuCode" placeholder="选择状态" filterable  size="small" clearable>
                                <el-option
                                v-for="item in menuMap"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <!-- <el-form-item class="item" prop="selectBrand">
                            <el-select v-model="searchForm.selectBrand" placeholder="选择品牌" size="small" clearable>
                                <el-option
                                v-for="item in brandOptions"
                                :key="item.brandId"
                                :label="item.brandName"
                                :value="item.abiBrandCode">
                                </el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item class="item" prop="selectChannel">
                            <el-select v-model="searchForm.selectChannel" placeholder="选择渠道" filterable  size="small" clearable>
                                <el-option
                                v-for="item in channelOptions"
                                :key="item.key"
                                :label="item.value"
                                :value="item.key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" prop="selectType">
                            <el-select v-model="searchForm.selectType" placeholder="选择形式" filterable  size="small" clearable>
                                <el-option
                                v-for="(key,value) in typeOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="item" style="margin-right: 12px;" prop="selectLevel">
                            <el-select v-model="searchForm.selectLevel" placeholder="选择级别" filterable  size="small" clearable>
                                <el-option
                                v-for="(key,value) in levelOptions"
                                :key="value"
                                :label="key"
                                :value="value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="danger" size="small" @click="queryForm()">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="info" size="small" @click="resetForm()">重置</el-button>
                        </el-form-item>
                        </el-form>
                    </div>
                    <div class="item-btn">
                        <button class="btn-left" @click="viewReturn()">查看退回提报</button>
                        <button class="btn-right" v-show="!isQuotaApproval && isRegion" @click="viewReport()">发起提报</button>
                        <button class="btn-right" v-show="isQuotaApproval && (isBu || isHq)" @click="goApproval()">去审批</button>
                    </div>
                    <div class="card-box" >
                        <div class="card is-hover-shadow" v-for="(item) in cardData" :key="item.activityId" >
                        <div class="left">
                            <div class="left-top">
                                <div class="top-name">
                                    <span v-if="item.blockName">{{item.blockName}}</span>
                                    <span v-else>{{item.gpActivityPocDTOList[0].pocName}}</span>
                                    <span style="margin-left: 5px;" v-if="item.blockName && item.gpActivityPocDTOList">：
                                        <span>{{getToolsname(item,'saleName','、')}}</span>
                                    </span>
                                </div>
                                <div class="top-sign" v-if="item.themeInfoDTO">{{getBluename(item.themeInfoDTO.orgLevel)}}</div>
                                <!-- <span v-if="item.blockName">{{item.blockName}}</span>
                                <span v-else>{{item.gpActivityPocDTOList[0].pocName}}</span>
                                <span style="margin-left: 5px;" v-if="item.blockName && item.gpActivityPocDTOList">：<span>{{getToolsname(item,'saleName','、')}}</span></span> -->
                            </div>
                            <div class="left-second">
                                <div class="second-left">{{getToolsname(item,'activityName','-')}}</div>
                                <div  class="second-right">
                                    <span class="font-weight-bold">已提报:</span>
                                    <span style="margin-left: 5px;">{{item.submitCountQty}}场</span>
                                </div>
                            </div>
                            <div class="left-third">
                                <span class="font-weight-bold">活动时间：</span>
                                <span>{{getTime(item.beginTime)}}</span>
                                <span style="margin: 0px 5px;">-</span>
                                <span>{{getTime(item.endTime)}}</span>
                            </div>
                            <div class="left-last">
                                <span  class="font-weight-bold">区域：</span>
                                <span>{{getToolsname(item,'areaName','-')}}</span>
                                <span  class="font-weight-bold" style="margin-left: 25px;">提报售点要求：</span>
                                <span>{{getToolsname(item,'typeName')}}</span>
                            </div>
                        </div>
                        <div class="right">
                            <div class="right-top">
                                <span>{{item.activityStatusName}}</span>
                            </div>
                            <div class="right-btn">
                                <div style="margin-right: 5px;height: 30.4px;line-height:30.4px;" v-if="showRemovebtn(item)" >
                                    <DialogPop
                                        @confirm="cancelExecution(item)"
                                        :marLeft="true"
                                        :cancelExecution="true"
                                        isType="1"
                                        btnText="取消执行"
                                        centerText="是否确认取消执行？"
                                    ></DialogPop>
                                </div>
                                <button class="btn-left"  @click="activityDetail(item)">查看详情</button>
                                <button class="btn-right" @click="activityUpdate(item)" v-if="showUpdatebtn(item.activityStatus)">修改</button>
                                <!-- <button class="btn-right" @click="goApprovalitem(item)" v-if="showApprovaltebtn(item.activityStatus)">去审批</button> -->
                            </div>
                        </div>
                    </div>
                    </div>
                    <div v-if="cardData.length == 0">
                        <!-- style="height:50vh; line-height:50vh;text-align: center;" -->
                        <el-empty description="暂无数据"></el-empty>
                    </div>
                    <div class="pagination" v-if="cardData.length > 0">
                        <el-pagination
                        background
                        layout="total, prev, pager, next"
                        :total="searchForm.total"
                        :current-page="searchForm.page"
                        :page-size="searchForm.pageSize"
                        @current-change="handleCurrentChange"
                        />
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    import { mapGetters,mapState } from 'vuex'
    import ContentHeader from '@/components/content-header'
    import gameplanApi from '../../api/gameplan'
    import DialogPop from "./components/dialog-pop.vue";
    export default {
      name: 'activity-report',
      components: {
        ContentHeader,
        DialogPop
      },
      data () {
        return {
            searchForm: {
                themeId:'',
                prId: '', // PR编码
                prName: '', // PR名称
                blockName:'', // 街区名称
                pocName:'',// 售点名称
                activityName: '', // 活动名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                page: 1,
                pageSize: 10,
                total:0,
                menuCode: '', //状态
                selectType: '', //形式
                selectLevel: '', //级别
                buCode:'',
                regionCode:'',
                buOrgId:'',
                passedStatus:''
            },
            channelOptions: [], // 渠道下拉菜单
            brandOptions: [], // 品牌下拉菜单
            typeOptions:[],
            levelOptions:[],
            cardData: [],
            loading: true,
            isRegion: false,
            // menuMap:[
            //     {key:'01',value:"待提报"},
            //     {key:'04',value:"审批中"},
            //     {key:'02',value:"执行中"},
            //     {key:'03',value:"已退回"},
            //     {key:'09',value:"已完成"},
            // ],
            menuMap:[
                // {key:'0',value:"待提交"},
                // {key:'100',value:"待Regin审批"},
                {key:'200',value:"BU审批"},
                {key:'300',value:"HQ审批"},
                {key:'350',value:"待供应商确认"},
                {key:'400',value:"执行中"},
                {key:'500',value:"已完成"},
                {key:'900',value:"已取消"}
            ],
            buArr:[],
            regionArr: [],
            isBu: false,
            isHq: false,
            isSkip: false,
            isQuotaApproval: false,
            themeList: [],
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
        ...mapState({
          regionOrgList: state => state.gameplan.regionOrgList
        }),
      },
      watch: {
        'searchForm.selectChannel': {
            handler (to, from) {
                this.getStyleMap()
                // this.searchForm.selectType = ''
                // this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
            },
        'searchForm.selectType': {
            handler (to, from) {
                this.getLevelMap()
                // this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
        },
        'searchForm.buCode': {
            handler (to, from) {
            },
            deep:true,
            immediate:true
        },
        regionOrgList(){
          this.regionArr = this.regionOrgList
        }
      },
      watch: {
        'searchForm.selectChannel': {
            handler (to, from) {
                this.getStyleMap()
                // this.searchForm.selectType = ''
                // this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
            },
        'searchForm.selectType': {
            handler (to, from) {
                this.getLevelMap()
                // this.searchForm.selectLevel = ''
            },
            deep:true,
            immediate:true
        },
        'searchForm.buCode': {
            handler (to, from) {
            },
            deep:true,
            immediate:true
        },
      },
      created () {
        if (this.$route.query.routerType == 'skip') {
            this.isSkip = true
        }
        if (this.$route.query.routerType == 'quotaApproval') {
            this.isQuotaApproval = true
        }
        if (this.$route.query.isPassed == 'true') {
            this.searchForm.passedStatus = '01'
        }
        this.searchForm.selectChannel = this.$route.query.themeChannelCode
        this.searchForm.selectType = this.$route.query.themeStyleCode
        this.searchForm.selectLevel = this.$route.query.themeLevelCode
        // this.searchForm.activityName = this.$route.query.themeName
        this.searchForm.themeId = this.$route.query.themeId
        if(this.userInfo.employeeLevel >= 90) {
            this.isHq = true
            this.searchForm.buCode = this.$route.query.buCode
            this.searchForm.regionCode = this.$route.query.regionCode
        }
        if(this.userInfo.employeeLevel >= 60 && this.userInfo.employeeLevel < 90) {
            // console.log(this.userInfo,'this.userInfo');
            this.isBu = true
            this.searchForm.buCode = this.userInfo.buCode
            this.searchForm.regionCode = this.$route.query.regionCode
        }
        if(this.userInfo.employeeLevel === 50 || this.userInfo.employeeLevel === 45){
            this.isRegion = true
            this.searchForm.buCode = this.userInfo.buCode
            this.searchForm.regionCode = this.$route.query.regionCode
        }
        if(this.isHq||this.isBu) this.getBuList()
        else if(this.isRegion) this.$store.dispatch('getThemeRegionList')
        this.init()
      },
      mounted () {
      },
      methods: {
        init () {
            this.getSelectChannel()
            this.getThemeNamelist()
            this.getThemelist()
        },
        getBluename (name) {
            if (name == 'region') {
                return 'Region'
            } else if (name == 'bu') {
                return 'BU'
            } else if (name == 'hq') {
                return 'HQ'
            } else {
                return 'error'
            }
        },
        cahngeBu () {
            if (!this.searchForm.buCode) {
                return this.searchForm.regionCode = ''
            }
            if (this.buArr.length > 0) {
                for (const item of this.buArr) {
                    if (item.orgCode == this.searchForm.buCode) {
                        this.searchForm.buOrgId = item.orgId
                        this.getRegionList()
                    }
                }
            }
        },
        getToolsname (item,type,sign) {
            if (type == 'saleName') {
                let arr = item.gpActivityPocDTOList
                if (arr.length > 0) {
                    let name = arr.map((item)=>{
                        return item.pocName
                    }).join(sign)
                    return name
                }
            } else if (type == 'activityName') {
                let arr = []
                // console.log(item.themeName,'红界精酿小酒馆');
                if (item.themeName) {
                    arr.push(item.themeName)
                }
                if (item.themeChannelName) {
                    arr.push(item.themeChannelName.split('|')[1])
                }
                if (item.themeStyleName) {
                    arr.push(item.themeStyleName)
                }
                if (item.themeLevelName) {
                    arr.push(item.themeLevelName)
                }
                let name = arr.map((item)=>{
                    return item
                }).join(sign)
                return name
            }
            else if (type == 'areaName') {
                let arr = []
                if (item.regionName) {
                    arr.push(item.regionName.split('|')[0])
                }else {
                    return
                }
                let name = arr.map((item)=>{
                    return item
                }).join(sign)
                return name
            }
            else if (type == 'typeName') {
                let pocRelateType = item.gpThemeDetailDTO.pocRelateType
                if (pocRelateType == '0') {
                    return '无售点'
                }else if (pocRelateType == '1') {
                    return '单售点'
                } else if (pocRelateType == '2') {
                    return '多售点'
                } else {
                    return 'error'
                }
            }
            else {
                return 'error'
            }
        },
        //取消执行
        async cancelExecution (item) {
            let params = {
                "activityId":item.activityId
            }
            const { data } = await gameplanApi.cancelExecute(params);
            console.log(data,data.resultCode);
            if (data.resultCode === "0") {
                this.$message.success("取消执行操作成功")
                this.getThemelist()
            }
        },
        async getBuList () {
            let params = {}
            const { data } = await gameplanApi.getBuList(params);
            if (data.resultCode === "0") {
                this.buArr = data.resultData.buList || [];
                this.cahngeBu()
            }
        },
        async getRegionList () {
            if (!this.searchForm.buOrgId) {
                return
            }
            let params = {
                buOrgId: this.searchForm.buOrgId
            }
            const { data } = await gameplanApi.getRegionList(params);
            if (data.resultCode === "0") {
                this.regionArr = data.resultData.regionList || [];
            }
        },
        async getStyleMap () {
            let params = {
                channelCode:this.searchForm.selectChannel
            }
            const { data } = await gameplanApi.getGameplanConfigStyleMap(params);
            if (data.resultCode === "0") {
                this.typeOptions = data.resultData.themeStyleMap || {};
            }
        },
        async getLevelMap () {
            let params = {
                styleCode:this.searchForm.selectType
            }
            const { data } = await gameplanApi.getGameplanConfigLevelMap(params);
            if (data.resultCode === "0") {
                this.levelOptions = data.resultData.themeLevelMap || {};
            }
        },
        // 获取下拉框状态map
        async getSelectType () {
            let params = {
                name:'gpActivityStatusMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.menuMap = data.data.resultData.gpActivityStatusMap
        },
        getChannel(a,b){
            let themeChannels = a
            let arr = themeChannels.map((item) => {
                    return item.themeChannelEnName
                }).join(b)
            return arr
        },
        getTime (timestamp) {
            if (timestamp === 0 || timestamp == null) {
                return ''
            } else {
                var date = new Date(parseInt(timestamp)) // 时间戳为13位的话需要parseInt下
                const Y = date.getFullYear() + '-'
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
                // const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
                // const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
                // const s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
                return Y + M + D
            }
        },
        getThemeNamelist () {
            let params = {
                // buCode:this.searchForm.buCode,
                // regionCode:this.searchForm.regionCode,
            }
            gameplanApi.getSubmitnameList(params).then(res=>{
                if (res.data.resultCode === '0') {
                    this.themeList = res.data.resultData.themeNameList || []
                }
            })

        },
        getThemelist () {
            this.loading = true
            let params = {
                page: this.searchForm.page,
                pageSize: this.searchForm.pageSize,
                themeName: this.searchForm.activityName,
                themeChannelCode: this.searchForm.selectChannel,
                themeStyleCode: this.searchForm.selectType,
                themeLevelCode: this.searchForm.selectLevel,
                activityStatus: this.searchForm.menuCode,
                blockName:this.searchForm.blockName,
                pocName:this.searchForm.pocName,
                regionCode:this.searchForm.regionCode,
                themeId: this.searchForm.themeId,
                buCode:this.searchForm.buCode,
                passedStatus:this.searchForm.passedStatus
            }
            gameplanApi.getGamepalnReportlist(params).then(res=>{
                if (res.data.resultCode === '0') {
                    let pageData = res.data.resultData.pageInfo
                    this.searchForm.page = Number(pageData.curPage)
                    this.searchForm.total = Number(pageData.totalCounts)
                    // this.themeList = res.data.resultData.themeNameList || []
                    if (res.data.resultData.activityList == null) {
                        this.cardData = []
                    } else {
                        this.cardData = res.data.resultData.activityList
                    }
                    this.loading = false
                } else {
                    this.loading = false
                    console.log('接口error');
                }
            })
        },
        async getSelectChannel () {
            // name=gpThemeChannelMap&type=list或map
            let params = {
                name:'gpThemeChannelMap',
                type:'list'
            }
            let data =  await gameplanApi.getGamepalnChannelquery(params)
            this.channelOptions = data.data.resultData.gpThemeChannelMap
        },
        async getSelectBrand () {
            let data =  await gameplanApi.getGamepalnBrandquery()
            this.brandOptions = data.data.resultData.btmpBrandDTOList
        },
        handleCurrentChange (val) {
            this.searchForm.page = val
            this.getThemelist()
        },
        queryForm (val) {
            this.$refs.searchForm.validate((valid) => {
                if (valid) {
                    this.searchForm.page =1
                    this.getThemelist()
                } else {
                    return false;
                }
            });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            this.searchForm.selectChannel =''
            this.searchForm.selectType = ''
            this.searchForm.selectLevel = ''
            this.searchForm.activityName = ''
            this.searchForm.themeId = ''
            this.searchForm.menuCode = ''
            this.searchForm.passedStatus = ''
            if (this.isHq) {
                this.searchForm.buCode = ''
                this.regionArr = []
            }
            if (this.isBu) {
                this.searchForm.buCode = this.userInfo.buCode
            }
            this.searchForm.regionCode = ''
            this.searchForm.page = 1
            this.getThemelist()
        },
        // 活动详情-查看
        activityDetail (item) {
            this.$router.push({path:'/gameplan/activity-report-detail',query:{'activityId':item.activityId,'themeDetailId':item.themeDetailId,'typeStatus':item.activityStatus,'routerType':'view'}})
        },
        // 活动修改--编辑
        activityUpdate (item) {
            this.$router.push({path:'/gameplan/activity-report-detail',query:{'activityId':item.activityId,'themeDetailId':item.themeDetailId,'typeStatus':item.activityStatus,'routerType':'update'}})
        },
        // 查看退回提报
        viewReturn () {
            this.$router.push({path:'/gameplan/activity-report-return'})
        },
        // 发起提报
        viewReport () {
            this.$router.push({path:'/gameplan/activity-report-start'})
        },
        // 去审批
        goApproval () {
            this.$router.push({path:'/gameplan/submit-approval/wait'})
        },
        // 去审批Item
        goApprovalitem (item) {
            console.log(item,'去审批Item');
            this.$router.push({path:'/gameplan/submit-approval-detail',query:{themeId:item.themeId}})
        },
        // 是否展示修改按钮
        showUpdatebtn (activityStatus) {
            // console.log(activityStatus,'是否展示修改按钮');
            if (this.isQuotaApproval) {
                return false
            }
            // if (this.isSkip) {
            //     return false
            // }
            if (this.isRegion == false) {
                return false
            }
            if (activityStatus == '200' || activityStatus == '400') {
                return true
            } else {
                return false
            }
        },
        // 是否展示取消执行按钮
        showRemovebtn (item) {
            // console.log(activityStatus,'是否展示修改按钮');
            let activityStatus = item.activityStatus
            let isExecute = item.isExecute
            if (this.isQuotaApproval) {
                return false
            }
            if (this.isRegion == true && (activityStatus == '350' || activityStatus == '400') && isExecute) {
                return true
            } else {
                return false
            }
        },
        // 是否展示去审批按钮
        showApprovaltebtn (activityStatus) {
            if (!this.isQuotaApproval) {
                return false
            }
            if (this.isBu && activityStatus == '200' ) {
                return true
            }
            if (this.isHq && activityStatus == '300' ) {
                return true
            }
            return false
        },
      }
    }
</script>
<style lang="scss" scoped>
    .el-menu-item.is-active {
        // color: #fff;
        border: none;
        font-weight: bold;
        // background-color: rgba(51, 51, 51, 0.2) !important;
    }
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    .trade-nav-panel {
      width: 80%;
      margin: 0 auto;
      background: $base-white;
      .el-menu-item:last-child{
        border-bottom: 0;
      }
      ::v-deep .el-card__header {
        height: 70px;
        line-height: 35px;
      }
      ::v-deep .el-card__body {
        padding: 0;
      }
      .panel-header {
        font-size: 16px;
        font-weight: 700;
        color:#CD1231;
      }
      ::v-deep .el-menu {
        border-right: 0;
      }
      ::v-deep .el-menu-item {
        border-bottom: 1px solid $base-grey5;
      }
      ::v-deep .el-menu-item.is-active {
        color: $base-red;
      }
    }
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
      .content-right {
        height: 100%;
        box-sizing: border-box;
        position: relative;
        // a {
        //   text-decoration: none;
        //   color: #000;
        // }
        .search {
            .searchForm {
                width: 1000px;
                margin: auto;
                .item {
                    width:140px;
                    ::v-deep .el-input__inner {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
                .selcetItem{
                    ::v-deep .el-select-dropdown__wrap {
                        max-height: 274px;
                        max-width: 200px;
                    }
                }
            }
        }
        .item-btn {
            position: absolute;
            top: 70px;
            right: 120px;
            font-size: 14px;
            text-align: right;
            .btn-left {
                height: 29px;
                padding: 4px 12px;
                border-radius: 4px;
                border: 1px solid #CD1231;
                background-color: #FFFFFF;
                color: #CD1231;
                cursor: pointer;
            }
            .btn-right {
                height: 29px;
                padding: 4px 12px;
                border-radius: 4px;
                border: 1px solid #CD1231;
                background-color: #CD1231;
                color: #FFFFFF;
                margin-left: 15px;
                cursor: pointer;
            }
        }
        .card-box {
            .card {
                margin: auto;
                width: 980px;
                display: flex;
                justify-content: flex-start;
                padding:10px 10px;
                background-color: #FFFFFF ;
                border-radius: 8px;
                font-size: 14px;
                margin-bottom: 20px;
                .left {
                    text-align: left;
                    color: #101010;
                    width: 70%;
                    font-size: 14px;
                    .left-top {
                        // line-height: 27px;
                        // font-size: 18px;
                        // font-weight: 600;
                        // word-wrap: break-word;
                        // word-break: normal;
                        // word-break: break-all;
                        padding-bottom: 10px;
                        font-size: 18px;
                        display: flex;
                        .top-name {
                            font-weight: 600;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                        .top-sign {
                            color: #FFFFFF;
                            background-color: #40A5EE;
                            margin-left: 10px;
                            padding: 0px 8px;
                            line-height: 18px;
                            height: 18px;
                            font-size: 14px;
                            margin-top: 2px;
                            font-weight: 600;
                        }
                    }
                    .left-second {
                        display: flex;
                        padding-bottom: 10px;
                        .second-left {
                            margin-right: 25px;
                            line-height: 20px;
                            word-wrap: break-word;
                            word-break: normal;
                            word-break: break-all;
                        }
                        .second-right {
                            flex: 1;
                            min-width: 100px;
                            line-height: 20px;
                        }
                    }
                    .left-third {
                        line-height: 20px;
                        display: flex;
                        justify-content: flex-start;
                        padding-bottom: 10px;
                    }
                    .left-last {
                        line-height: 20px;
                        font-weight: 500;
                        padding-bottom: 10px;
                    }
                }
                .right {
                    flex: 1;
                    text-align: right;
                    position: relative;
                    .right-top {
                        line-height: 27px;
                        color: #CD1231 ;
                        font-size: 16px;
                        font-weight: 600;
                    }
                    .right-btn {
                        position: absolute;
                        bottom: 5px;
                        right: 0;
                        // margin-top: 43px;
                        font-size: 14px;
                        text-align: right;
                        font-family: Microsoft Yahei;
                        display: flex;
                        .btn-left {
                            width: 84px;
                            height: 32px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #FFFFFF;
                            color: #CD1231;
                            cursor: pointer;
                        }
                        .btn-right {
                            width: 84px;
                            height: 32px;
                            // padding: 4px 12px;
                            border-radius: 4px;
                            border: 1px solid #CD1231;
                            background-color: #CD1231;
                            color: #FFFFFF;
                            margin-left: 20px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .pagination {
            position: relative;
            bottom: 0;
            text-align: center;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
    }
</style>
